import React, { Component, PureComponent, Fragment } from 'react'
import { Map, List, fromJS } from 'immutable'
import moment from 'moment'
import Consent from './consent'

/*
 <div className="approve-feedback">
  <label htmlFor="feedback">
    { t('approval.feedback') }
  </label>
  <textarea id="feedback"
    value={ feedback }
    onChange={ onFeedbackChange } />
</div>

 */

export default function MaterialList(props) {
  let {
    materials,
    approves,
    onClick,
    groups: materialGroups,
    groupId: openGroupId,
    approvedAt,
    isClient,
    hasRelated,
    canSubmit,
    submitting,
    handleSubmit,
    reopened,
    showConsent,
    consent,
    notfound,
    t,
  } = props

  if (!materials.size) return <div className="approve-materials-empty">{t('approve.materialListEmpty')}</div>

  let groups = [
    {
      title: t('approve.materials.videos'),
      items: materialGroups.get('video', List()),
      id: 'video',
      icon: 'film',
    },
    {
      title: t('approve.materials.images'),
      items: materialGroups.get('image', List()),
      id: 'image',
      icon: 'image',
    },
    {
      title: t('approve.materials.articles'),
      items: materialGroups.get('article', List()),
      id: 'article',
      icon: 'file',
    },
  ]

  return (
    <Fragment>
      <Consent {...props} />
      {showConsent ? null : openGroupId === 'final' ? (
        <div className={`approve-message approve-message--${canSubmit ? '' : 'error'}`}>
          {canSubmit
            ? isClient
              ? t('approve.final.messageSuccessClient')
              : t('approve.final.messageSuccess')
            : t('approve.final.messageError')}
        </div>
      ) : approvedAt && !reopened ? (
        <div className="approve-message approve-message--success">{t('approve.messageApproved')}</div>
      ) : (
        <div className="approve-message approve-message--info">
          {isClient ? t('approve.messageIntroClient') : t('approve.messageIntroDefault')}
          {hasRelated ? (
            <Fragment>
              <br />
              <br />
              <b>{t('approve.messageHasRelated')}</b>
            </Fragment>
          ) : null}
        </div>
      )}
      {showConsent && !consent ? null : (
        <div className="approve-materials-list">
          {openGroupId === 'final' ? <div className="approve-materials-list-title">{t('approve.summary')}</div> : null}
          {groups.map(({ title, items, icon, id }, key) => {
            if (!items.size) return null

            let classes = ['approve-materials-list-group-button']
            if (id === openGroupId) classes.push('approve-materials-list-group-button--active')

            if (approves.get(id) === true) classes.push('approve-materials-list-group-button--approve-yes')

            if (approves.get(id) === false) classes.push('approve-materials-list-group-button--approve-no')

            return (
              <div className="approve-materials-list-group" key={key}>
                <button className={classes.join(' ')} onClick={e => e.preventDefault() & onClick(id)}>
                  <div className="approve-materials-list-group-button-icon">
                    <span>
                      <i className={`fa fa-${icon}`} />
                    </span>
                  </div>
                  <div className="approve-materials-list-group-button-content">
                    <b>{title}</b>
                    <span>
                      {t('approve.materials.files')}: {items.size}
                    </span>
                  </div>
                </button>
              </div>
            )
          })}
        </div>
      )}
      {openGroupId === 'final' && consent ? (
        <div className="approve-materials-list-submit-wrapper">
          <div className="approve-materials-list-submit">
            {submitting ? (
              <button
                className="approve-footer-action-button approve-footer-action-button--submit"
                onClick={e => e.preventDefault()}>
                <i className="fa fa-spin fa-spinner" />
                {t('approve.action.submitting')}
              </button>
            ) : canSubmit ? (
              <button
                className="approve-footer-action-button approve-footer-action-button--submit"
                onClick={e => e.preventDefault() & handleSubmit()}>
                <i className="fa fa-save" />
                {t('approve.action.submit')}
              </button>
            ) : null}
          </div>
        </div>
      ) : null}
    </Fragment>
  )
}
